import { FormControl, InputLabel, MenuItem } from "@mui/material";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import { ISortConfig } from "../types";
import { ReactElement } from "react";

interface ITopPanelProps  {
  updateSortConfig: (sortData: ISortConfig) => void;
  sortData: ISortConfig;
}

const SortPanel = ({ sortData, updateSortConfig }: ITopPanelProps): ReactElement =>  {

  const onUpdateValue = (field: keyof ISortConfig, value: any) => {
    if (field === "orderBy") {
      sortData[field] = value;
    } else {
      sortData[field] = value;
    }

    updateSortConfig(sortData);
  };

  return (
    <div className="display-flex-row">
      <FormControl sx={{ margin: 1, minWidth: 134, width: 134 }}>
        <InputLabel sx={{ transform: "translate(0px, 0px) scale(0.75) !important" }}>Order By</InputLabel>
        <Select
          variant="standard"
          value={sortData.orderBy ?? "NONE"}
          displayEmpty={true}
          onChange={(event: SelectChangeEvent) => onUpdateValue("orderBy", event.target.value)}>
          <MenuItem value={"NONE"}>None</MenuItem>
          <MenuItem value={"DIMENSION"}>Dimension</MenuItem>
          <MenuItem value={"VALUE"}>Value</MenuItem>
        </Select>
      </FormControl>


      <FormControl sx={{ margin: 1, minWidth: 134, width: 134 }}>
        <InputLabel sx={{ transform: "translate(0px, 0px) scale(0.75) !important" }}>Order</InputLabel>
        <Select
          variant="standard"
          value={sortData.orderAsc ? "ASC" : "DESC"}
          displayEmpty={true}
          onChange={(event: SelectChangeEvent) => onUpdateValue("orderAsc", event.target.value === "ASC")}>
          <MenuItem value={"ASC"}>ASC</MenuItem>
          <MenuItem value={"DESC"}>DESC</MenuItem>
        </Select>
      </FormControl>
    </div>
  );
};

export default SortPanel;
